<script setup>
/* Imports */
import {
  computed,
} from 'vue';

import {
  mapGetters,
} from '../helpers/mainHelpers.js';

/* Props */
const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  showProductName: {
    type: Boolean,
    default: true,
  },
  subtitle: {
    type: String,
    default: '',
  },
  showSubtitle: {
    type: Boolean,
    default: true,
  },
  partNumber: {
    type: String,
    default: '',
  },
  showPartNumber: {
    type: Boolean,
    default: true,
  },
});

/* Store - Getters */
const {
  getPartNumberTitle: partNumberTitle,
} = mapGetters();

/* Computed */
const formattedPartNumber = computed(() => (partNumberTitle?.value && typeof partNumberTitle.value === 'string' ? partNumberTitle.value.toLowerCase() : ''));
const titleClass = computed(() => (props.showSubtitle ? 'app__product__info__title--no-margin' : ''));

</script>

<template>
  <div id="js__product__meta">
    <g-heading
      v-if="showProductName"
      id="js__product__info__name"
      class="app__product__info__title"
      :class="titleClass"
      text-align="left"
    >
      <h1 v-html="props.title" />
    </g-heading>
    <g-heading
      v-if="props.showSubtitle"
      id="js__product__info__variation"
      class="app__product__info__subtitle"
    >
      <h2 v-html="props.subtitle" />
    </g-heading>
    <p
      v-if="props.showPartNumber"
      id="js__product__info__part-number"
      class="app__product__info__part-number"
    >
      <g-copy
        type="footnote"
        mb="none"
      >
        <span
          id="js__product__info__part-number__label"
          class="app__product__info__part-number__label"
          v-html="`${formattedPartNumber}:`"
        />
        <span
          id="js__product__info__part-number__text"
          class="app__product__info__part-number--light"
        >
          {{ props.partNumber }}
        </span>
      </g-copy>
    </p>
  </div>
</template>

<style lang="scss" scoped>
.app__product__info {

  &__title {
    :deep(h1) {
      margin-bottom: $spacing-xs;
    }

    &--no-margin {
      :deep(h1) {
        margin-bottom: 0;
      }
    }
  }

  &__subtitle {
    :deep(h2) {
      all: unset; // Remove all existing heading styles
      // Apply custom styles for the subtitle
      @include font-primary();
      @include font-primary-weight-regular();
      font-size: $font-size-small;
      margin-bottom: $spacing-xs;
    }
  }

  &__part-number {
    margin: 0;

    :deep(.g__copy) {
      font-size: $font-size-small;
    }

    &__label {
      text-transform: capitalize;
    }

    &--light {
      padding-left: $spacing-xs;
    }
  }
}
</style>
